export type Item = Record<string, any>

// Given an array of objects, checks if any of the object's properties contain a non-null value
const hasNonEmptyItems = <T extends Item[]>(arr: T | null) => {
    const hasNonNullValue = ([key, val]: [string, any]) => key !== '__typename' && !!val

    return arr?.some((f) => Object.entries(f).some(hasNonNullValue))
}

export default hasNonEmptyItems
